import { createFileRoute } from '@tanstack/react-router';
import { AutomationsJourneyForward } from '@/pages/workspaces/automations/[campaignId]/journeys/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/journeys/',
)({
  component: AutomationsJourneyForward,
});
